(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('ActivityHistoryDeleteController',ActivityHistoryDeleteController);

    ActivityHistoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'ActivityHistory'];

    function ActivityHistoryDeleteController($uibModalInstance, entity, ActivityHistory) {
        var vm = this;

        vm.activityHistory = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ActivityHistory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
